<template>
    <div>
        <!-- <alert-loading></alert-loading> -->
        <b-row align-h="between">
            <b-col>
                <date-range-picker v-model="reportRange"></date-range-picker>
            </b-col>
            <b-col class="text-right">
                <b-button variant="default" @click.prevent="downloadReport()">
                <span>Generuj XLS</span>
                <svg-icon name="download"/>
                </b-button>
            </b-col>
        </b-row>
        <alert-loading v-if="loading"></alert-loading>
        <div  v-if="!loading" class="table-responsive">
            <table class="table table-striped table-bordered table-hover table-clickable table-search">
                <thead>
                <tr>
                    <th>Numer umowy</th>
                    <th>Data zawarcia</th>
                    <th>Nazwa klienta</th>
                    <th>Kwota ({{currency.name}})</th>
                    <th>Prowizja</th>
                    <th>% netto ({{currency.name}})</th>
                </tr>
                </thead>
                <tbody>
                    <template v-for="item in items.list">
                        <tr v-for="agreement in item.agreements">
                            <td class="td-no_link">{{agreement.fullNumber}}</td>
                            <td class="td-no_link">{{agreement.date.date | date}}</td>
                            <td class="td-no_link">{{agreement.customerName}}</td>
                            <td class="td-no_link">{{agreement.amount|amountFormat}}</td>
                            <td class="td-no_link">{{agreement.commission}}%</td>
                            <td class="td-no_link">{{agreement.commissionAmount|amountFormat}} </td>
                        </tr>

                        <tr class="tr-summary">
                            <td colspan="3" class="td-no_link"></td>
                            <td class="td-no_link"><strong>{{item.totalAmount|amountFormat}}</strong></td>
                            <td colspan="2" class="td-no_link"></td>
                        </tr>
                    </template>
                </tbody>
                <tfoot>
                <tr class="tr-summary">
                    <td colspan="3" class="td-no_link text-right">Suma</td>
                    <td class="td-no_link"><strong>{{items.totalAmount|amountFormat}} </strong></td>
                    <td class="td-no_link"></td>
                    <td class="td-no_link"><strong>{{items.totalCommission|amountFormat}} </strong></td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import moment from 'moment'
  import http from './../../utils/http'

  export default {
    props: {
      currency: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        reportRange: null,
      }
    },

    methods: {
      downloadReport(){
        const to =  moment(this.reportRange[1]).format('YYYY-MM-DD')
        const from = moment(this.reportRange[0]).format('YYYY-MM-DD')
        http.download('/download/reports/sales/' + this.currency.id + '?from=' + from + '&to=' + to + '&');
      },
      ...mapActions({
        getItems: 'report/sales/getItems'
      })
    },

    computed: {
      ...mapGetters({
        items: 'report/sales/items',
        loading: 'report/sales/loading',
        errors: 'report/sales/errors',
      })
    },
    watch:{
      reportRange: function (data) {
        this.getItems({ currency: this.currency, from: this.reportRange[0], to: this.reportRange[1]} )
      }
    },
    created () {
      if(!this.reportRange){
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        this.reportRange = [
          start,
          end
        ];
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Sales.vue?9b40a848